import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, getDimension } = useContext(Context);

  const [countries, setCountries] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllCategory = async () => {
    const response = await getData("/all-cab-type");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "cab_type_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,getValues,
  } = useForm();
  const descriptionValue = watch("facilities");
  useEffect(() => {
    register("facilities", {
      required: "Facilities is required.",

    });
  }, [register]);
  const featuresAndAminitiesValue = watch("long_description");
  useEffect(() => {
    register("long_description", {
      required: "view More is required.",
    });
  }, [register]);

  const includedValue = watch("included");
  useEffect(() => {
    register("included", {
      required: "Included is required.",

    });
  }, [register]);
  const excludedValue = watch("excluded");
  useEffect(() => {
    register("excluded", {
      required: "Excluded is required.",
    });
  }, [register]);
  const imageFile = watch("image");
  const onSubmit = async (data) => {
    try {
      // console.log("faq_category_id :- ", data?.faq_category_id);
      const DataToSend = new FormData();
      DataToSend.append("image", data?.image[0]);
      DataToSend.append("cab_type_id", data?.cab_type_id?.value);
      DataToSend.append("name", data?.name);
      DataToSend.append("facilities", data?.facilities);
      DataToSend.append("included", data?.included);
      DataToSend.append("long_description", data?.long_description);
      DataToSend.append("excluded", data?.excluded);
      DataToSend.append("cancellation", data?.cancellation);
      DataToSend.append("fuel", data?.fuel);
      DataToSend.append("seater", data?.seater);
      const response = await postData(`/masters/cabs`, DataToSend);
      
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };



  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
          // className="stateclass"
          >
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Cab Type</Form.Label>
                    <Controller
                      name="cab_type_id" // name of the field
                      {...register("cab_type_id", {
                        required: "Select Cab type",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.cab_type_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={countries}
                        />
                      )}
                    />
                    {errors.cab_type_id && (
                      <span className="text-danger">
                        {errors.cab_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Cab Name</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Cab Name"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "cab Name is required",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Seater</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="seater"
                          placeholder="seater"
                          className={classNames("", {
                            "is-invalid": errors?.seater,
                          })}
                          {...register("seater", {
                            required: "Seater is required",
                            min: {
                              value: 0,
                              message: "Seater must be 0 or greater",
                            },
                            valueAsNumber: true, // To ensure the value is treated as a number
                            validate: (value) =>
                              value >= 1 && value <= 100 || "Seater must be between 1 and 100",
                          })}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Prevent non-numeric input
                          }}
                        />
                      </InputGroup>
                      {errors.seater && (
                        <span className="text-danger">{errors.seater.message}</span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>


              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Fuel</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="fuel"
                          placeholder="fuel"
                          className={classNames("", {
                            "is-invalid": errors?.fuel,
                          })}
                          {...register("fuel", {
                            required: "fuel is required",
                          })}
                        />
                      </InputGroup>
                      {errors.fuel && (
                        <span className="text-danger">
                          {errors.fuel.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Cancellation</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="cancellation"
                          placeholder="cancellation"
                          className={classNames("", {
                            "is-invalid": errors?.cancellation,
                          })}
                          {...register("cancellation", {
                            required: "cancellation is required",
                          })}
                        />
                      </InputGroup>
                      {errors.cancellation && (
                        <span className="text-danger">
                          {errors.cancellation.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Facilities</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="facilities"
                          placeholder="Facilities"
                          className={classNames("", {
                            "is-invalid": errors?.facilities,
                          })}
                          {...register("facilities", {
                            required: "Facilities is required",
                          })}
                        />
                      </InputGroup>
                      {errors.facilities && (
                        <span className="text-danger">
                          {errors.facilities.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>


              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Form.Label className="text-left">Image</Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        type="file"
                        {...register("image", {
                          required: "Image is required",
                          validate: async (value) => {
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              // const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 352 && sizes.height !== 236) {
                              //   return "Image width and height must be 352 px and 236 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={3}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview</Form.Label>

                    {imageFile && imageFile?.length > 0 && (
                      <div className="image-preview-container mt-3">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    )}
                  </Row>
                </div>
              </Col>

              {/* <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    {" "}
                   
                    <Col sm={12}>
                      <Form.Label className="text-center">
                        Facilities
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="facilities" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: "facilities is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={descriptionValue || ""}
                              onBlur={(newContent) => {
                                setValue("facilities", newContent);
                                trigger("facilities");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.facilities && (
                        <span className="text-danger">
                          {errors.facilities.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col> */}


              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">

                    <Col sm={12}>
                      <Form.Label className="text-center">
                        View More
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="long_description" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required:
                              " Long Description is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={featuresAndAminitiesValue || ""}
                              onBlur={(newContent) => {
                                setValue(
                                  "long_description",
                                  newContent
                                );
                                trigger("long_description");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.long_description && (
                        <span className="text-danger">
                          {errors.long_description.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    {" "}
                    {/* Align to left */}
                    {/* description */}
                    <Col sm={12}>
                      <Form.Label className="text-center">
                        Included
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="included" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: "included is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={includedValue || ""}
                              onBlur={(newContent) => {
                                setValue("included", newContent);
                                trigger("included");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.included && (
                        <span className="text-danger">
                          {errors.included.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>



              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">

                    <Col sm={12}>
                      <Form.Label className="text-center">
                        Excluded
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="excluded" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required:
                              " excluded is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={excludedValue || ""}
                              onBlur={(newContent) => {
                                setValue(
                                  "excluded",
                                  newContent
                                );
                                trigger("excluded");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.excluded && (
                        <span className="text-danger">
                          {errors.excluded.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
